import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcNotify32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m22 5c0-2.768 2.232-5 5-5s5 2.232 5 5-2.232 5-5 5-5-2.232-5-5z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcNotify32;
